import {AccrualRule, AccrualRuleCreate, AccrualRuleUpdate} from "./@types/AccrualRule";
export class AccrualRuleRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/accrual_rules';
    }
    async getAll(): Promise<AccrualRule[]>{
        const response = await this.httpService.get<TKResponse<AccrualRule[]>>(this.baseUrl);
        return response.data
            .map(item => ({ ...item, id: item.accrual_rule_id }))
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }
    async getOne(id: number): Promise<AccrualRule> {
        const response = await this.httpService.get<TKResponse<AccrualRule>>(`${this.baseUrl}/${id}`);
        return { ...response.data, id: response.data.accrual_rule_id };
    }
    async create(data: AccrualRuleCreate): Promise<AccrualRule> {
        const response = await this.httpService.post<TKResponse<AccrualRule>, AccrualRuleCreate>(this.baseUrl, { data });
        return response.data;
    }
    async update(id: number, data: AccrualRuleUpdate): Promise<AccrualRule> {
        const response = await this.httpService.patch<TKResponse<AccrualRule>, AccrualRuleUpdate>(`${this.baseUrl}/${id}`, { data });
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

